module.exports = __webpack_public_path__ + "img/3.5206d8dd.png";